import instance from "./axios";
import { UPLOAD_EVENT_IMAGE } from "../api/endPoint";
import {
  getCloudinaryCloudName,
  getCloudinaryUploadPreset,
} from "../config/cloudinaryBase";

/**
 * Builds a usable img src: full HTTPS URLs pass through; legacy values are prefixed with the Cloudinary base.
 */
export const resolveCloudinaryImageSrc = (
  image,
  cloudinaryBaseUrl,
  fallbackRelative = "dummy-profile.png"
) => {
  if (image == null || image === "") {
    return `${cloudinaryBaseUrl}${fallbackRelative}`;
  }
  const s = String(image).trim();
  if (/^https?:\/\//i.test(s)) {
    return s;
  }
  return `${cloudinaryBaseUrl}${s}`;
};

/**
 * Converts HTML (e.g. from ReactQuill) to plain text for API storage.
 */
export const htmlToPlainText = (html) => {
  if (html == null || html === "") return "";
  const s = String(html);
  if (typeof document !== "undefined") {
    const el = document.createElement("div");
    el.innerHTML = s;
    const text = el.textContent || el.innerText || "";
    return text.replace(/\u00a0/g, " ").trim();
  }
  return s.replace(/<[^>]*>/g, "").replace(/\u00a0/g, " ").trim();
};

export const uploadEventImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);
  const res = await instance.post(UPLOAD_EVENT_IMAGE, formData);
  const url = res?.data?.url ?? res?.url;
  if (!url) {
    throw new Error(
      typeof res?.message === "string" ? res.message : "Image upload failed"
    );
  }
  return url;
};

export const uploadFile = async (file) => {
  const cloudName = getCloudinaryCloudName();
  const formdata = new FormData();
  formdata.append("file", file);
  formdata.append("cloud_name", cloudName);
  formdata.append("upload_preset", getCloudinaryUploadPreset());

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${cloudName}/upload`,
    {
      method: "post",
      mode: "cors",
      body: formdata,
    }
  );

  const json = await res.json();
  if (json?.error) {
    throw new Error(json.error?.message || "Cloudinary upload failed");
  }
  const secureUrl = json?.secure_url;
  if (!secureUrl) {
    throw new Error("Cloudinary upload failed: missing image URL");
  }
  const legacyKey = "web/Project-images/";
  const relative = secureUrl.split(legacyKey)[1];
  if (relative) {
    return relative;
  }
  return secureUrl;
};
